import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface EditModeModalProps {
  isEditModeDialogOpen: boolean;
  setIsEditModeDialogOpen: (value: boolean) => void;
  onEditModeSelect: (updateExisting: boolean) => void;
}

const EditModeModal = ({
  isEditModeDialogOpen,
  setIsEditModeDialogOpen,
  onEditModeSelect,
}: EditModeModalProps) => {
  return (
    <Dialog
      open={isEditModeDialogOpen}
      onClose={() => {
        setIsEditModeDialogOpen(false);
      }}
    >
      <DialogTitle>Edit the existing survey or create a new one?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Editing a published survey can have unintended consequences on
          existing submissions for that survey. Generally speaking, you want to
          create a new version of the survey with added or removed fields to
          preserve existing submissions.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "16px",
        }}
      >
        <div>
          <Button
            onClick={() => onEditModeSelect(true)}
            color="secondary"
            variant="outlined"
          >
            Edit Existing Survey
          </Button>
        </div>
        <div>
          <Button
            onClick={() => onEditModeSelect(false)}
            color="primary"
            variant="contained"
          >
            Create New Survey
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default EditModeModal;
